import { defineComponent as _defineComponent } from 'vue'
import type { Props as BadgeProps } from '@/core/components/base/indicator/Badge.vue';
import { computed, toRefs } from '@nuxtjs/composition-api';
import type { DefineComponent } from 'vue';

interface Props {
    menuItemFont?: 'mobile' | 'desktop' | 'responsive',
    linkTag?: string | DefineComponent,
    theme?: 'light' | 'dark',
    title?: string,
    badgeProps?: BadgeProps,
    to: string,
    disabled?: boolean,
    active?: boolean,
}
export default /*#__PURE__*/_defineComponent({
  __name: 'Secondary',
  props: {
    menuItemFont: { default: 'responsive' },
    linkTag: null,
    theme: null,
    title: null,
    badgeProps: null,
    to: null,
    disabled: { type: Boolean },
    active: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { menuItemFont: 'mobile' | 'desktop' | 'responsive', linkTag?: string | DefineComponent, theme?: 'light' | 'dark', title?: string, badgeProps?: BadgeProps, to: string, disabled?: boolean, active?: boolean };

;



const {
    menuItemFont,
    linkTag,
    theme,
    title,
    badgeProps,
    to,
    disabled,
    active,
} = toRefs(props);

const fontType = computed(() => menuItemFont.value + 'Font');

return { __sfc: true,props, menuItemFont, linkTag, theme, title, badgeProps, to, disabled, active, fontType }
}

})